import { ELedgerDto } from '@/@apis/cloud-api'

export default function capitalize(value: string) {
   return typeof value !== 'string' ? '' : value.charAt(0).toUpperCase() + value.slice(1)
}

export function getFilename(path: string) {
   const match = path.match(/[^\\/]+\.\w+$/) // Dosya adı ve uzantısını yakalar
   return match ? match[0] : null
}

export function getFilenameWithoutExtension(path: string) {
   const fileName = getFilename(path)!

   return fileName?.substring(0, fileName.lastIndexOf('.'))
}

export function getELedgerReportDocumentBasePath(bookPath: string, eLedgerDto: ELedgerDto) {
   // Windows ayırıcısını kontrol et
   const isWindows = bookPath.includes('\\')
   const delimiter = isWindows ? '\\' : '/'

   // 'Datas' kelimesinin bulunduğu ilk index'i bul
   const parts = bookPath.split(delimiter)
   const datasIndex = parts.indexOf('Datas')

   if (datasIndex !== -1) {
      // 'Datas' kelimesine kadar olan yolu platforma özgü ayırıcı ile birleştir
      return [...parts.slice(0, datasIndex), 'Datas', eLedgerDto.id, `${eLedgerDto.reportDocumentPackageName}.xml`].join(delimiter)
   } else {
      // 'Datas' bulunamazsa tüm yolu döndür
      return bookPath
   }
}
